//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import User from "../user";
import Notify from "../notify";
import SwitchButtons from "../switchButtons";
export default {
  name: "LayoutHeader",
  components: {SwitchButtons, Notify, User},
  data: () => ({
  }),
  created() {
    this.$store.dispatch('notify/setNotifications')
  },
  methods: {
    showMobileMenu() {
      this.$store.commit('mobileMenu/changeMobileMenuValue', true)
    }
  },
  computed: {
    mobileMenuValue() {
      return this.$store.getters['mobileMenu/getMobileMenuValue']
    }

  }
}
